module.exports = function() {
  return new Worker(__webpack_public_path__ + "32980974980133b01b2c.worker.js");
};